<template>
  <div>
    <v-parallax light src="/kim_background.jpg" height="500" min-height="400">

      <v-row align="start" align-content="start" justify="start" style="max-height: 200px;">
        <img src="header_logo.png" class="mx-3 my-3" style="height:45px;" />
      </v-row>
        <v-row align='center' align-content='start' justify='center'>
          <v-col cols='12'>
            <h1 class='login-page-claim mx-12'>{{$t('Blocker.notOpen')}}</h1>
          </v-col>
          <v-col cols='12'>
            <p class='login-page-claim body-1 mx-12 mt-5'>{{$t('Blocker.statusIs')}}: <b>{{$t(`RunStatus.${runState}`)}}</b></p>
          </v-col>
        </v-row>
    </v-parallax>

    <v-parallax dark src="/kim_splash_login.jpg" height="800">
      <div class="kipat-login-background-blur">

      </div>
      <v-container class="kipat-login-container">
        <v-row align="center" align-content="center" justify="center">

          <v-card max-width="600">
            <v-card-title class="justify-center">{{$t('Blocker.options')}}</v-card-title>

            <v-card-text align="center">
              <p>{{$t('Blocker.optionsText')}}</p>
              <!-- todo if AppRun Endpoint can return a normal AppRunObject that contains the runstatus we can actually use this again -->
<!--              <v-btn color="primary" class="my-5" @click="refresh">
                <v-icon>mdi-refresh</v-icon>
                {{$t('Blocker.optionReload')}}
              </v-btn>-->
              <br/>
              <v-btn color="primary" class="my-5" @click="logout">
                <v-icon>mdi-logout</v-icon>
                {{$t('Blocker.optionLogout')}}
              </v-btn>
            </v-card-text>

          </v-card>

        </v-row>
      </v-container>
    </v-parallax>

  </div>
</template>

<script>
import { mapState } from 'vuex';

  export default {
    name: 'RunStatusBlocked',
    components: { },
    computed: {
      ...mapState({
        runInfo: (state) => state.runInfo,
        runState: (state) => state.signalR.runState
      }),
    },
    methods: {
      refresh() {
        // Status Updater is not used anymore -> The Reload Status EventBus Listener is also not available anymore
        // EventBus.$emit(EVENTS.RELOAD_STATUS, true);
      },
      logout() {
        this.$store.commit('clearState');
        this.$hub.close();
        this.$router.push('/login');
      },
    }
  };
</script>

<style scoped>

</style>
